import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectorsLocale } from '../../redux/locale/localeReducer';
import { buildLocale } from '../../utils/buildLocale';
import ReviewStars from '../Products/ProductReviews/ReviewStars';

export type OrderFeedbackItem = { rating: number; text: string | null };

interface IProps {
  itemBlockTitle: string;
  updateFeedbackItemData: (data: OrderFeedbackItem) => void;
}

const OrderFeedbackItemComponent = (props: IProps) => {
  const DEFAULT_RATE = 0;
  const MAX_RATE = 5;
  const { itemBlockTitle, updateFeedbackItemData } = props;
  const currentTranslate = useSelector(selectorsLocale.getTranslate);
  const [rating, setRating] = useState(DEFAULT_RATE);
  const [text, setText] = useState<string | null>(null);
  const [isCommentAvailable, setIsCommentAvailable] = useState(false);

  const changeComment = (value: string) => {
    setText(value);
    updateFeedbackItemData({ rating, text: value?.length ? value : null });
  };

  const handleRatingChanging = (newRating: number) => {
    setRating(newRating);
    const isCommentAvailable = newRating < MAX_RATE && newRating > DEFAULT_RATE;
    setIsCommentAvailable(isCommentAvailable);
    if (!isCommentAvailable) {
      setText(null);
    }
    updateFeedbackItemData({ rating: newRating, text: isCommentAvailable ? text : null });
  };

  return (
    <div>
      <div className="order-feedback-block_title">
        <div className="title">{itemBlockTitle}</div>
        <ReviewStars isEditable={true} ratingValue={rating} onSubmit={(n) => handleRatingChanging(n)} />
      </div>
      {isCommentAvailable && (
        <div className="row">
          <div className="col-12">
            <div className="form-item">
              <label>{buildLocale(currentTranslate, 'comment')}</label>
              <textarea
                className="form-control"
                onChange={(e) => changeComment(e.target.value)}
                onBlur={() => updateFeedbackItemData({ rating, text })}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderFeedbackItemComponent;
